module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-09-7ef132fead1aaf5fe6c6fd49964c9a22.jpg";